<template>
  <div class="tl">
    <Menu />
    <div class="remoteSupport">
      <section class="bnr">
        <div class="inner">
          <p class="title">强安全、更高效、更专业</p>
          <p class="title">的远程技术支持</p>
        </div>
        <div class="bkg">
          <img
            class="bnr_img"
            src="https://todeskcdnspeed.todesk.com/2024070817332861cb91b122620c.png"
            alt="技术支持"
          />
          <div class="desc">
            <p class="desc_item">
              <img src="@/assets/remoteSupport/remoteSupportV2/check.svg" alt="">
              <span>安全性能强劲，多项权威认证、设备轻松部署</span>
            </p>
            <p class="desc_item">
              <img src="@/assets/remoteSupport/remoteSupportV2/check.svg" alt="">
              <span>安装一键下达，界面易用更直观，操作得心应手</span>
            </p>
            <p class="desc_item">
              <img src="@/assets/remoteSupport/remoteSupportV2/check.svg" alt="">
              <span>集中式管理平台，颗粒度更细软件高兼容</span>
            </p>
            <p class="desc_item">
              <img src="@/assets/remoteSupport/remoteSupportV2/check.svg" alt="">
              <span>轻松跨平台，业界高性价比，无缝切换更省心</span>
            </p>
          </div>
        </div>
        <div class="btns">
          <a
            class="link_btn btn1 epBtn1"
            href="https://console.todesk.com/#/register"
            >免费试用</a
          >
          <a class="link_btn btn2 epBtn2" href="https://www.todesk.com/mobile/#/contact_mobile"
            >联系我们</a
          >
        </div>
      </section>
      <section class="partner" v-if="logo_list.length > 0">
        <div class="img">
          <img
            v-for="(item, index) in logo_list"
            :key="index"
            :src="item"
            alt=""
            class="logo_item"
          />
        </div>
      </section>
      <div id="showPositon"></div>
      <section class="prospect">
        <div class="inner">
          <h2 class="title">企业IT运维和技术支持<br>首选ToDesk</h2>
          <h6 class="sub_title">
            相比于其他远程支持方案，ToDesk是行业内高性价<br>比、高效安全的远程技术支持服务标杆
          </h6>
          <div class="bx">
            <div
              class="bx_item"
              v-for="(item, index) in prospect_list"
              :key="index"
            >
              <img class="item_img" :src="item.icon" alt="" />
              <p class="item_title">{{ item.title }}</p>
              <div class="item_desc">
                <p v-for="(item2, index2) in item.desc" :key="index2">
                  {{ item2 }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section v-if="show" class="pltfrm">
        <h2 class="ptitle">更适合企业的高效技术支持</h2>
        <div class="subTitle">
          <div>·  为您的公司构建统一的技术支持平台，提高效率，规范管理，保护信息架构。</div>
          <div>·  破解多分支多厂区难题，一站式解决员工桌面支持、机房运维、外部供应商合规接入</div>
        </div>
        <el-collapse v-model="activeNames" @change="collapseChange">
          <el-collapse-item title="对客户技术支持" name="1">
            <div class="detail_views">
              <img
                class="view_pic"
                src="https://todeskcdnspeed.todesk.com/mobile/remoteSupport/plt_pic0.png"
                alt="Internal Technical Support"
              />
            </div>
            <div class="p_info_big">
              <div class="p_info">
                <div class="left">
                  <p
                    class="pl_desc"
                    v-for="(item, index) in platform_list[0].desc"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </div>
                <img
                  class="pl_bgi"
                  src="https://todeskcdnspeed.todesk.com/mobile/remoteSupport/plt_bgi0.png"
                  alt=""
                />
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="设备运维" name="2">
            <div class="detail_views">
              <img
                class="view_pic"
                src="https://todeskcdnspeed.todesk.com/mobile/remoteSupport/plt_pic1.png"
                alt="Internal Technical Support"
              />
            </div>
            <div class="p_info_big">
              <div class="p_info">
                <img
                  class="pl_bgi"
                  src="https://todeskcdnspeed.todesk.com/mobile/remoteSupport/plt_bgi1.png"
                  alt=""
                />
                <div class="left">
                  <h3 class="pl_title">{{ platform_list[1].title }}</h3>
                  <p
                    class="pl_desc"
                    v-for="(item, index) in platform_list[1].desc"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="接受供应商技术支持" name="3">
            <div class="detail_views">
              <img
                class="view_pic"
                src="https://todeskcdnspeed.todesk.com/mobile/remoteSupport/plt_pic2.png"
                alt="Internal Technical Support"
              />
            </div>
            <div class="p_info_big">
              <div class="p_info">
                <img
                  class="pl_bgi"
                  src="https://todeskcdnspeed.todesk.com/mobile/remoteSupport/plt_bgi2.png"
                  alt=""
                />
                <div class="left">
                  <h3 class="pl_title">{{ platform_list[2].title }}</h3>
                  <p
                    class="pl_desc"
                    v-for="(item, index) in platform_list[2].desc"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="帮员工解决电脑问题" name="4">
            <div class="detail_views">
              <img
                class="view_pic"
                src="https://todeskcdnspeed.todesk.com/mobile/remoteSupport/plt_pic3.png"
                alt="Internal Technical Support"
              />
            </div>
            <div class="p_info_big">
              <div class="p_info">
                <img
                  class="pl_bgi"
                  src="https://todeskcdnspeed.todesk.com/mobile/remoteSupport/plt_bgi3.png"
                  alt=""
                />
                <div class="left">
                  <h3 class="pl_title">{{ platform_list[3].title }}</h3>
                  <p
                    class="pl_desc"
                    v-for="(item, index) in platform_list[3].desc"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </section>
      <div class="virtue">
        <h2 class="virtueTitle">ToDesk在技术支持上的<br>优势有哪些</h2>
        <div v-for="(item,index) in virtue_list" :key="index">
          <div class="itemTitle">
            <img :src="require(`@/assets/remoteSupport/remoteSupportV2/virtue_icon${index}.svg`)" alt="">
            <p>{{ item.title }}</p>
          </div>
          <div class="virtueContCol" v-if="item.info.length > 1">
            <el-collapse :value="[`${index}-0`]">
              <el-collapse-item v-for="(subItem,subIndex) in item.info" :key="subIndex" :title="subItem.info_title" :name="index + '-' + subIndex">
                <div class="subDesc">
                  <p class="subDescItem" v-for="(descItem,descIndex) in subItem.info_items" :key="descIndex">· {{ descItem }}</p>
                </div>
                <img class="virtuePic" :src="subItem.pic" alt="">
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="virtueCont" v-else :key="index">
            <p class="contTile">{{ item.info[0].info_title }}</p>
            <div class="contDesc">
              <p class="contDescItem" v-for="(descItem,descIndex) in item.info[0].info_items" :key="descIndex">{{ descItem }}</p>
            </div>
            <img class="contPic" :src="item.info[0].pic" alt="">
          </div>
        </div>
      </div>
      <div class="pdn ftr2">
        <h3 class="sub_title">23项措施 全方位安全保障</h3>
        <div class="desc_bx" id="desc_bx">
          <div
            v-for="(item, index) in ftr2_list"
            :key="index"
            class="desc_item"
            :class="{ active: ftr2_active == index }"
            @click="ftr2Active(index)"
          >
            {{ item.tab }}
          </div>
        </div>
        <img
          v-for="(item, index) in ftr2_list"
          :key="index"
          v-touch:swipe.left="ftr2Left"
          v-touch:swipe.right="ftr2Right"
          class="desc_pic"
          :src="item.pic"
          v-show="index === ftr2_active"
          :alt="item.tab"
        />
      </div>
      <div class="safe_info">
        <div class="safe_item safe_item1">
          <div class="item" v-for="(item, index) in sf_info1" :key="index">
            <img class="icon" :src="item.icon" :alt="item.title" />
            <p class="title">{{ item.title }}</p>
            <p class="sub_title">{{ item.desc }}</p>
          </div>
        </div>
        <div class="safe_item safe_item2">
          <div
            class="item"
            v-for="(item, index) in sf_info2"
            :key="index + sf_info2.length"
          >
            <img class="icon" :src="item.icon" :alt="item.title" />
            <p class="title">{{ item.title }}</p>
            <p class="sub_title">{{ item.desc }}</p>
          </div>
        </div>
      </div>
      <div id="position"></div>
      <Certificate />
      <Price :pageView="'tech'" />
      <div class="contact">
        <h2 class="title">
          <span class="t2">企业级安全</span>
          <span class="t1">的远程办公</span>
        </h2>
        <div class="btns">
          <a href="https://console.todesk.com/#/register" class="epBtn1"
            >立即试用</a
          >
        </div>
      </div>
    </div>
    <div class="bottomTry" id="bottomTry">
      <a href="https://console.todesk.com/#/register" class="btn epBtn1"
          >立即试用</a
        >
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import Certificate from "@/components/Common/Certificate.vue";
import Price from "@/components/Common/Price.vue";
import { mapState } from "vuex";
import { videoReady, Throttle } from "../../utils/util";
export default {
  components: {
    Menu,
    Footer,
    Price,
    Certificate,
  },
  data() {
    return {
      to_register: "https://console.todesk.com/#/register",
      show: false,
      logo_list: [
        require("@/assets/partner/Walmart_logo@2x.png"),
        require("@/assets/partner/zh_logo@2x.png"),
        require("@/assets/partner/tongcheng.png"),
        require("@/assets/partner/bohai_logo@2x.png"),
        require("@/assets/partner/yuncong_logo@2x.png"),
        require("@/assets/partner/youkeshu.svg"),
      ],
      prospect_list: [
        {
          title: "简单易用，轻松上手",
          icon: require('@/assets/remoteSupport/remoteSupportV2/easy.svg'),
          desc: [
            "功能直观清晰，上手学习成本低，",
            "集中式统一管理，快速提升运维效率",
          ],
        },
        {
          title: "多重验证，护卫运控安全",
          icon: require('@/assets/remoteSupport/remoteSupportV2/safe.svg'),
          desc: [
            "采用企业级多因素认证 (MFA)，",
              "提升全场景身份安全信息防护",
          ],
        },
        {
          title: "专业远控解决方案",
          icon: require('@/assets/remoteSupport/remoteSupportV2/pro.svg'),
          desc: [
            "服务40万+企业用户，挖掘行业痛点，",
            "提供更加贴近业务的远控解决方案",
          ],
        },
      ],
      active_plt: 0,
      plt_timer: null,
      platform_list: [
        {
          title: "对客户技术支持",
          desc: [
            "· 连接客户电脑，实现远程演示、远程诊断、远程调试",
            "· 提升沟通效率，快速高质量解决客户问题",
            "· 使用SOS免安装被控端，客户放心无压力",
          ],
        },
        {
          title: "设备运维",
          desc: [
            "· 远程连接机房电脑、服务器",
            "· 远程巡检、系统维护、软件升级、调试排障",
            "· 严格权限体系+审计日志，规范运维操作",
          ],
        },
        {
          title: "接受供应商技术支持",
          desc: [
            "· 外部供应商接入调试业务系统和设备",
            "· 统一管理不同供应商的访问权限",
            "· 为外部人员分配临时账号、限定访问时间",
            "· 管理员全程观看监督，可随时干预操作",
          ],
        },
        {
          title: "帮员工解决电脑问题",
          desc: [
            "· 无论员工身处何地，都能获得技术支持",
            "· 电脑问题远程解决，IT不奔忙，员工不久等",
            "· 总部统一设立帮助中心，精简分支架构",
          ],
        },
      ],
      activeNames: ['1'],
      activeNamesLast: ['1'],
      ftr2_active: 0,
      ftr2_list: [
        {
          left: 0,
          tab: '日志记录',
          pic:'https://todeskcdnspeed.todesk.com/2024070511574661c7810f1a30c4.png',
        },
        {
          left: 0,
          tab: '操作录屏',
          pic:'https://todeskcdnspeed.todesk.com/2024070511575561c78117d1b0c0.png',
        },
        {
          left: 70,
          tab: '可控文件传输',
          pic:'https://todeskcdnspeed.todesk.com/2024070511580461c78120d362b4.png',
        },
        {
          left: 160,
          tab: '明暗水印',
          pic:'https://todeskcdnspeed.todesk.com/2024070511581461c7812a2c1c4c.png',
        },
        {
          left: 220,
          tab: '安全验证',
          pic:'https://todeskcdnspeed.todesk.com/2024070511582361c78132ae3854.png',
        },
        {
          left:300,
          tab: '专属配置',
          pic:'https://todeskcdnspeed.todesk.com/2024070511583161c7813a98422c.png',
        },
      ],
      sf_info1: [
        {
          title: "黑白名单",
          desc: "严格管控终端受控权限",
          icon: "https://todeskcdnspeed.todesk.com/2024070811133061cb3cc28ba3c0.png",
        },
        {
          title: "隐私屏",
          desc: "被控端工作内容防窥保密",
          icon: "https://todeskcdnspeed.todesk.com/mobile/remoteSupport/sf_icon2@2x.png",
        },
        {
          title: "系统锁定",
          desc: "超时、最小化、连接时都可锁定",
          icon: "https://todeskcdnspeed.todesk.com/mobile/remoteSupport/sf_icon3@2x.png",
        },
        {
          title: "双因认证",
          desc: "多重验证方式确保本人操作",
          icon: "https://todeskcdnspeed.todesk.com/mobile/remoteSupport/sf_icon4@2x.png",
        },
      ],
      sf_info2: [
        {
          title: "临时账号授权",
          desc: "临时访问权限，预定生效时间",
          icon: "https://todeskcdnspeed.todesk.com/mobile/remoteSupport/sf_icon5@2x.png",
        },
        {
          title: "一次性连接码",
          desc: "连接码单次失效，不怕被盗",
          icon: "https://todeskcdnspeed.todesk.com/mobile/remoteSupport/sf_icon6@2x.png",
        },
        {
          title: "端到端加密",
          desc: "数据传输VPN保护和非对称加密",
          icon: "https://todeskcdnspeed.todesk.com/mobile/remoteSupport/sf_icon7@2x.png",
        },
        {
          title: "可控剪贴板",
          desc: "可禁用主被控间复制粘贴",
          icon: "https://todeskcdnspeed.todesk.com/mobile/remoteSupport/sf_icon8@2x.png",
        },
      ],
      scrollLen: [450,340,450,200],
      virtue_list: [
        {
          cycle:true,
          active:0,
          timer:null,
          title: '火速直连，多场景智能适配',
          info:[
            {
              info_title: 'SOS免安装免配置',
              info_items: [
                '远控连接轻松上阵，分享链接一键控制',
                '安全配置不缩小，精简也有强保护'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070915553761ccbdaeb2d90c.png',
            },
            {
              info_title: '企业版与个人版互通',
              info_items: [
                '企业用户可直接远控ToDesk个人版客户端',
                '外部客户问题轻松解决，技术支持服务更方便'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070917414561ccd56883b4b8.png',
            },
            {
              info_title: 'web连接',
              info_items: [
                '无需下载客户端，打开网页一键发起控制',
                '降低远控门槛，随时随地发起远程支持'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070915560261ccbdc700d364.png',
            }
          ]
        },
        {
          cycle:true,
          active:0,
          timer:null,
          title: '快速批量部署，自动关联设备信息',
          info: [
            {
              info_title: '上万台设备一键部署',
              info_items: [
                '支持命令行静默安装',
                '自动绑定企业分组设备配置'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070511552261c78086761fe0.png',
            },
            {
              info_title: '定制专属企业LOGO客户端',
              info_items: [
                '彰显专业品牌形象'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070511553561c78092840354.png',
            }
          ]
        },
        {
          active:0,
          title: '一屏看多屏，处理问题快人一步',
          info: [
            {
              info_title: '屏幕墙可同时查看、控制多台设备屏幕',
              info_items: [
                '实时监测重要设备的运转状态'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070511554861c7809f1c7638.png',
            }
          ]
        },
        {
          active:0,
          title: '文件批量分发，内外部协作更高效',
          info: [
            {
              info_title: '规模集中更新软件，自动完成升级任务',
              info_items: [
                '文件类型不设限制，群发文件省心省力'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070910410061cc775cc2cf60.png',
            }
          ]
        },
        {
          active:0,
          title: '无人值守IOT安卓设备',
          info: [
            {
              info_title: '无人值守几乎所有的安卓设备',
              info_items: [
                '物联网设备轻松实现无人值守，极大地提升异地远程运维效率'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070910431561cc77dd2ee4d4.png',
            }
          ]
        },
        {
          active:0,
          title: '构建高效服务工单系统',
          info: [
            {
              info_title: '客户端界面可直接发起工单求助',
              info_items: [
                '工单信息统一管理，快速响应',
                '全流程记录，操作规范又安全'
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070511562961c780c5f269fc.png',
            },
          ]
        },
        {
          active:0,
          title: '语音通话，服务更敏捷',
          info: [
            {
              info_title: '实时语音协助，快速沟通问题',
              info_items: [
                '支持24小时全程开启',
              ],
              pic: 'https://todeskcdnspeed.todesk.com/2024070511564161c780d1af8940.png',
            },
          ]
        },
      ],
    };
  },
  mounted() {
    videoReady();
    // this.mountedInit();
    this.$nextTick(() => {
      this.show = true;
      this.setPltChange();
      setTimeout(() => {
        const _views = document.getElementsByClassName('detail_views');
        _views[0].scrollLeft = 450;
      }, 200);
    });
    window.addEventListener('scroll', this.checkScrollPosition);
  },
  methods: {
    getPositionTop(p) {
      const element = document.getElementById(p);
      let rect = element.getBoundingClientRect();
      return rect.top + (document.documentElement.scrollTop || document.body.scrollTop);
    },
    checkScrollPosition: Throttle(function () {
      const scrollPosition = window.scrollY || window.pageYOffset;
      const position0 = this.getPositionTop('position');
      const position1 = this.getPositionTop('showPositon');
      if (scrollPosition + document.documentElement.clientHeight + 100 > position0 || scrollPosition + document.documentElement.clientHeight - 30 < position1) {
        document.getElementById('bottomTry').style.display = 'none';
      } else{
        document.getElementById('bottomTry').style.display = 'block';
      }
    }, 300),
    collapseChange() {
      if(this.activeNames.length > this.activeNamesLast.length) {
        const num = this.findExtraValue(this.activeNames,this.activeNamesLast);
        if(num) {
          setTimeout(() => {
            const _views = document.getElementsByClassName('detail_views');
            _views[num - 1].scrollLeft = this.scrollLen[num - 1];
          }, 200);
        }
      }
      this.activeNamesLast = this.activeNames;
    },
    findExtraValue(arr1, arr2) {
      if (arr1.length > arr2.length) {
          [arr1, arr2] = [arr2, arr1];
      }
      const countMap = {};
      for (const value of arr1) {
          countMap[value] = (countMap[value] || 0) + 1;
      }
      for (const value of arr2) {
          if (!countMap[value] || countMap[value] === 0) {
              return value;
          } else {
              countMap[value] -= 1;
          }
      }
      return null;
    },
    // 平台切换
    pltChange(index) {
      if (index == this.active_plt) {
        return;
      } else {
        clearInterval(this.sf_timer);
        this.sf_timer = null;
        this.startPltChange(index);
        this.setPltChange();
      }
    },
    setPltChange() {
      this.sf_timer = setInterval(() => {
        let next_index = 0;
        if (this.active_plt == 3) {
          next_index = 0;
        } else {
          next_index = this.active_plt;
          next_index++;
        }
        this.startPltChange(next_index);
      }, 5000);
    },
    startPltChange(next_index) {
      this.active_plt = next_index;
    },
    ftr2Right() {
      if (this.ftr2_active == 0) {
        this.ftr2_active = 5;
      } else {
        this.ftr2_active--;
      }
      document.getElementById('desc_bx').scrollLeft = this.ftr2_list[this.ftr2_active].left;
    },
    ftr2Left() {
      if (this.ftr2_active == 5) {
        this.ftr2_active = 0;
      } else {
        this.ftr2_active++;
      }
      document.getElementById('desc_bx').scrollLeft = this.ftr2_list[this.ftr2_active].left;
    },
    ftr2Active(index) {
      this.ftr2_active = index;
      document.getElementById('desc_bx').scrollLeft = this.ftr2_list[index].left;
    },
  },
  beforeDestroy() {
    clearInterval(this.plt_timer);
    window.removeEventListener('scroll', this.checkScrollPosition);
  },
};
</script>
<style lang="less" scoped>
.remoteSupport {
  .bnr {
    position: relative;
    background-color: #F3F9FF;
    padding-top: 40px;
    padding-bottom: 30px;
    .inner {
      width: 100%;
      text-align: center;
      .title1 {
        padding-top: 184px;
      }
      .title {
        font-size: 30px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        line-height: 36px;
      }
      .desc {
        margin: auto;
        margin-top: 14px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #585f69;
        line-height: 22px;
        width: 336px;
      }

      .link_btn {
        margin-left: 8px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .bkg {
      margin-top: 18px;
      .bnr_img {
        width: 355px;
        height: auto;
      }
      .desc {
        padding-left: 18px;
        padding-right: 18px;
        margin-top: 18px;
        .desc_item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          &:last-of-type {
            margin-bottom: 0;
          }
          img {
            width: 18px;
            height: 18px;
            margin-right: 6px;
          }
          span {
            color: var(---04, #555A61);
            font-family: "PingFang SC";
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
      }
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      padding-left: 20px;
      padding-right: 20px;
      .btn1 {
        width: 158px;
        line-height: 44px;
        font-size: 16px;
      }
      .btn2 {
        width: 158px;
        line-height: 44px;
        font-size: 16px;
      }
    }
  }
  .partner {
    background: #fff;
    padding-top: 30px;
    padding-bottom: 12px;
    .img {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      .logo_item {
        height: 20px;
        margin-bottom: 18px;
        margin-left: 9px;
        margin-right: 9px;
      }
    }
  }
  .prospect {
    padding: 40px 0;
    .inner {
      .title {
        color: #222429;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 28px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
      .sub_title {
        color: #585F69;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 10px;
      }
      .bx {
        text-align: center;
        .bx_item {
          margin-top: 30px;
        }
        .item_img {
          width: 70px;
          height: 70px;
        }
        .item_title {
          margin-top: 15px;
          color: var(---02, #1D2024);
          text-align: center;
          font-family: "PingFang SC";
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }
        .item_desc {
          margin-top: 6px;
          p {
            color: var(---2, #616369);
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
      }
    }
  }
  .efficacy {
    padding-top: 32px;
    padding-bottom: 24px;
    background: #fff;
    .title {
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
    }
    .tabs {
      display: flex;
      margin-top: 22px;
      .tab_item {
        flex: 1;
        text-align: center;
      }
      img {
        width: 40px;
        height: 40px;
      }
      p {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        color: #222429;
        margin-top: 3px;
      }
      .tab_item.active {
        p {
          color: #216ed8;
        }
      }
    }
    .efficacy_line {
      width: 100%;
      height: 2px;
      background: #f5f6fa;
      margin-top: 11px;
      position: relative;
      .efficacy_move {
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 3px;
        background: #0065dd;
        width: 25%;
      }
    }
    .pic {
      padding-top: 15px;
      img {
        width: 100%;
      }
    }
  }
  .contrast {
    background: #f9f9f9;
    padding-left: 24px;
    padding-right: 24px;
    .title {
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      margin-left: -24px;
      margin-right: -24px;
    }
    .bx {
      margin-top: 24px;
      display: flex;
      justify-content: center;
    }
    .item {
      text-align: center;
      .item_title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        .t1 {
          color: #0065dd;
        }
      }
      .item_desc {
        margin-top: 8px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222429;
        height: 45px;
        .t2 {
          font-size: 14px;
          font-weight: 600;
        }
      }
      .item_pic {
        margin-top: 15px;
        width: 144px;
        height: 132px;
      }
    }
    .line {
      margin-left: 20px;
      margin-right: 20px;
      width: 0;
      height: 170px;
      border-left: 1px dashed #cccfd4;
      margin-top: 30px;
    }
  }
  .costs {
    padding: 32px 24px;
    background: linear-gradient(180deg, #e7edfa 0%, #f6f7f8 100%);
    .title {
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      margin-left: -20px;
      margin-right: -20px;
    }
    .item {
      position: relative;
      padding: 20px 30px;
      padding-bottom: 30px;
      background: #fff;
      border-radius: 8px;
      z-index: 1;
      .item_title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
      }
      .item_subtitle {
        margin-top: 2px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222429;
      }
      .item_bkg {
        position: absolute;
        right: 0;
        top: 43px;
        width: 126px;
        z-index: -1;
      }
    }
    .item1 {
      margin-top: 24px;

      .item_icon {
        position: absolute;
        right: 23px;
        top: 9px;
        width: 30px;
        z-index: -1;
      }

      .item_btn {
        margin-top: 45px;
        width: 100%;
        line-height: 48px;
        display: block;
        font-size: 18px;
      }
      .itemfts {
        margin-top: 20px;
        display: flex;
        flex-flow: row wrap;
        .itemfts_item {
          display: flex;
          align-items: center;
          width: 50%;
          margin-bottom: 8px;
          img {
            width: 16px;
          }
          span {
            margin-left: 6px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222429;
          }
        }
      }
      .togo {
        display: flex;
        margin-top: 10px;
        align-items: center;
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0065dd;
        }
        img {
          width: 14px;
          height: 14px;
          margin-left: 2px;
          margin-top: 2px;
        }
      }
    }
    .item2 {
      margin-top: 16px;
      background: linear-gradient(357deg, #3eb2ff 0%, #136ff0 100%);
      box-shadow: 0px 1px 6px 0px rgba(88, 95, 105, 0.14);
      .item_title {
        color: #fff;
      }
      .item_subtitle {
        color: rgba(255, 255, 255, 0.75);
      }
      .itemfts {
        width: 200px;
        margin-top: 20px;
        .itemfts_item {
          font-size: 13px;
          margin-bottom: 8px;
          text-shadow: 0px 0px 1px rgba(0, 50, 122, 0.1);
          color: rgba(255, 255, 255, 0.85);
        }
      }
      .item_btn {
        margin-top: 18px;
        width: 100%;
        line-height: 48px;
        background: #ffffff;
        border-radius: 4px;
        display: block;
        border: none;
        font-size: 18px;
      }
    }
  }
}

.trail {
  display: block;
  margin: auto;
  margin-top: 40px;
  width: 200px;
  line-height: 44px;
  height: 44px;
  font-size: 14px;
}
.pltfrm {
  background: #fff;
  padding: 32px 20px;
  .cont {
    max-width: 1200px;
    width: 100%;
    margin: auto;
  }
  .ptitle {
    text-align: left;
    font-weight: 600;
    font-size: 28px;
    line-height: 36px;
    color: #222429;
    margin-bottom: 20px;
    text-align: center;
    margin-left: -20px;
    margin-right: -20px;
  }
  .subTitle {
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: #585f69;
    padding-left: 10px;
    padding-right: 15px;
    margin-bottom: 30px;
    text-indent: -8px;
  }
  .tsubtitle {
    margin-top: 18px;
    font-weight: 400;
    color: #585f69;
    font-size: 14px;
    line-height: 16px;
  }
  ::v-deep .el-collapse-item__header {
    font-weight: 600;
    font-size: 18px;
    line-height: 17px;
    color: var(---7, #595959);
    height: 65px;
    &.is-active {
      color: var(---0, #1765D1);
    }
  }
  .detail_views {
    position: relative;
    overflow-y: hidden;
    overflow-x: auto;
    background: #2c2c2e;
    border-radius: 6px;
    padding: 0 20px 10px;
    scroll-behavior: smooth;
    .view_pic {
      width: 800px;
    }
    .view_area {
      position: absolute;
      width: 135px;
      height: 66px;
      opacity: 0;
      border-radius: 6px;
      cursor: pointer;
    }
    // 客户支持
    .view_area0 {
      left: 830px;
      top: 70px;
    }
    // 设备运维
    .view_area1 {
      left: 610px;
      top: 278px;
    }
    // 供应商技术支持
    .view_area2 {
      left: 830px;
      top: 207px;
    }
    // 电脑问题
    .view_area3 {
      left: 430px;
      top: 147px;
    }
  }
  .p_info_big {
    margin-top: 24px;
    overflow-y: hidden;
    overflow-x: auto;
    width: 100%;
  }
  .p_info {
    display: flex;
    width: 100%;
    border-radius: 10px;
    flex-direction: column;
    position: relative;
    z-index: 1;
    background: #F5F7FA;
    .left {
      width: 100%;
      padding: 18px 10px;
      box-sizing: border-box;
      .pl_title {
        font-size: 20px;
        line-height: 23px;
        color: #222429;
        font-weight: 600;
        margin: 10px 0;
      }
      .pl_desc {
        font-size: 14px;
        font-weight: 400;
        color: #585f69;
        line-height: 24px;
        text-indent: -8px;
        margin-left: 10px;
      }
    }
    .pl_bgi {
      width: 100%;
    }
  }
}
.ftr2 {
  background: #fff;
  text-align: center;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    .line {
      width: 20px;
      height: 2px;
      background: #216ed8;
      border-radius: 4px;
    }
    .t {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #216ed8;
      margin-left: 15px;
      margin-right: 15px;
    }
  }
  .sub_title {
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1e232a;
    margin-top: 8px;
  }
  .desc_title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #222429;
    line-height: 28px;
    margin-top: 24px;
  }
  .desc_bx {
    margin-top: 32px;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    height: 38px;
    .desc_item{
      display: inline-block;
      margin-left: 10px;
      margin-right: 10px;
    }
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }
  .desc_item {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #616369;
    line-height: 38px;
    position: relative;
    &.active {
      color: #fff;
      padding-left: 20px;
      padding-right: 20px;
      background: #161616;
      border-radius: 40px;
    }
  }
  .desc_pic {
    margin-top: 27px;
    width: 330px;
    height: auto;
    touch-action: pan-y;
  }
  .btn {
    margin: auto;
    margin-top: 40px;
    width: 311px;
    height: 48px;
    line-height: 48px;
    display: block;
    font-size: 18px;
  }
}
.safe_info {
  width: 100%;
  margin: auto;
  background: #fff;
  padding-bottom: 40px;
  .safe_item {
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    .item {
      text-align: center;
      width: 50%;
      margin-top: 15px;
      .icon {
        width: 56px;
        height: 56px;
        display: inline;
      }
      .title {
        font-size: 16px;
        line-height: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        margin-top: 8px;
      }
      .sub_title {
        margin-top: 4px;
        font-size: 12px;
        line-height: 17px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #585f69;
      }
    }
  }
  .safe_item1 {
    margin-bottom: 35px;
  }
}
.contact {
  width: 100%;
  height: 200px;
  background: #ffffff;
  background-image: url("~@/assets/epindex/bkg.png");
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 50px;
  box-sizing: border-box;
  .title {
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    .t1 {
      color: #222429;
    }
  }
  .btns {
    a {
      width: 335px;
      height: 48px;
      line-height: 48px;
      font-size: 18px;
      justify-content: center;
      display: flex;
      margin: 20px auto 0;
    }
  }
}
.virtue {
  padding: 40px 20px;
  background: #fff;
  .virtueTitle {
    color: #222429;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .itemTitle {
    display: flex;
    margin-top: 30px;
    margin-bottom: 15px;
    align-items: flex-start;
    img {
      width: 32px;
      height: 32px;
      margin-right: 6px;
    }
    p {
      color: #222429;
      font-family: "PingFang SC";
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
    }
  }
  .virtueContCol {
    ::v-deep .el-collapse-item__header{
      color: var(---7, #595959);
      font-family: "PingFang SC";
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      height: 65px;
      &.is-active {
        color: #1765D1;
      }
    }
    .subDesc {
      color: var(---03, #41464B);
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      margin-top: 6px;
    }
    .virtuePic {
      margin-top: 30px;
      width: 100%;
      height: auto;
    }
  }
  .virtueCont {
    .contTile {
      color: var(---0, #1765D1);
      font-family: "PingFang SC";
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    .contDesc {
      margin-top: 30px;
      .contDescItem {
        color: var(---03, #41464B);
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
    .contPic {
      margin-top: 30px;
      width: 100%;
      height: auto;
    }
  }
}
.bottomTry{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 12px 20px 24px;
  box-sizing: border-box;
  background: #FFF;
  box-shadow: 0px -1px 7.3px 0px rgba(0, 0, 0, 0.25);
  z-index: 1;
  display: none;
  .epBtn1 {
    width: 100%;
    display: block;
    line-height: 44px;
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
